import React from "react";
import TeamTileSmall from "../components/TeamTileSmall";
import { TeamInfo } from "./steps/PreferencesStep";
import countryArray from "../../utils/countryArray";

interface PickTeamsPanelProps {
  onTeamClick: (chosenTeam: TeamInfo) => void;
  /** Teams already picked — used to highlight their tiles. */
  chosenTeams: TeamInfo[];
  /** Free-text filter on the team name. */
  query?: string;
}

const PickTeamsPanel: React.FC<PickTeamsPanelProps> = ({
  onTeamClick,
  chosenTeams,
  query = "",
}) => {
  const normalized = query.trim().toLowerCase();
  const teams = normalized
    ? countryArray.filter((c) => c.countryName.toLowerCase().includes(normalized))
    : countryArray;

  if (teams.length === 0) {
    return <p className="pickTeams__empty">No teams match “{query.trim()}”.</p>;
  }

  return (
    <div className="pickTeams__grid">
      {teams.map(({ countryName, countryCode }) => (
        <TeamTileSmall
          key={`${countryCode}-country-${countryName}`}
          name={countryName}
          countryCode={countryCode}
          selected={chosenTeams.some((t) => t.countryCode === countryCode)}
          onTeamClick={onTeamClick}
        />
      ))}
    </div>
  );
};

export default PickTeamsPanel;
